import React, { Component } from "react";
import EditableDataContainer from "../containers/EditableDataContainer";
import ApiConfig from "../config/ApiConfig";
import { withRouterUtilities } from "../util/withRouterUtilities";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import { object } from "yup";
import PURCHASEIRQPropertyTypeView from "../views/IrqPropertyTypeView";
import StatusCheck from "../components/StatusCheck";

class RefinanceIrqPropertyTypePage extends Component {
  render() {
    const submitEndpoint =
      ApiConfig.protocol + ApiConfig.apiUri + ApiConfig.irqEndpoint;

    return (
      <div className="page-wrapper">
        <StatusCheck />
        <EditableDataContainer
          id="refinanceIrq"
          submitEndpoint={submitEndpoint}
          mutateRedux="always"
          isCreate
          isStep
          validationSchema={object()}
        >
          <PURCHASEIRQPropertyTypeView
            content={contentMap.RefinanceIrqPropertyTypePage}
            navigationsAway={customNavigationMap.RefinanceIrqPropertyTypePage}
          />
        </EditableDataContainer>
      </div>
    );
  }
}

export default withRouterUtilities(RefinanceIrqPropertyTypePage);
